import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttosatarscab() {



const cardData = {
  keyword: " Mumbai Airport to Satara Cab   ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Satara cab services, ensuring a smooth and stress-free journey for business trips, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai Airport to Satara convenient and hassle-free. The journey covers approximately 250–270 km via the Mumbai–Pune Expressway and NH48, typically taking 5–6 hours depending on traffic. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Satara cab travel.",

topPlaces: [
  {
    title: "Ajinkyatara Fort",
    description: "Ajinkyatara Fort is a historic hill fort in Satara, offering panoramic views of the city and surrounding hills. Travelers from Mumbai Airport can explore its ancient structures, enjoy trekking, and capture stunning photographs. The cab ensures a comfortable ride to the base of the fort before the trek."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the 'Valley of Flowers,' is famous for its seasonal wildflower blooms and rich biodiversity. Visitors arriving by cab can enjoy nature walks, photography, and the serene environment. It’s a must-visit destination for nature lovers traveling from Mumbai Airport."
  },
  {
    title: "Thoseghar Waterfalls",
    description: "Thoseghar Waterfalls is a scenic cascade near Satara, ideal for sightseeing and nature photography. Travelers using a cab from Mumbai Airport can enjoy the spectacular views, relax in the surrounding greenery, and capture memorable moments."
  },
  {
    title: "Chaphal Caves",
    description: "Chaphal Caves are ancient Buddhist rock-cut caves near Satara, featuring historic carvings and sculptures. Visitors traveling from Mumbai Airport can explore these archaeological sites comfortably by cab while learning about the region’s cultural heritage."
  },
  {
    title: "Yavateshwar Temple",
    description: "Yavateshwar Temple is a revered Hindu temple in Satara, known for its religious significance and peaceful ambiance. Travelers arriving from Mumbai Airport can visit the temple conveniently by cab and participate in rituals or enjoy the tranquil surroundings."
  },
  {
    title: "Satara Market",
    description: "Satara Market is a bustling local market offering regional products, handicrafts, and food. Travelers from Mumbai Airport can explore the market easily by cab, shop for souvenirs, and experience the local culture and cuisine of Satara."
  },
  {
    title: "Vajrai Waterfalls",
    description: "Vajrai Waterfalls is a spectacular waterfall located near Satara, known for its height and scenic beauty. Visitors traveling by cab can enjoy the natural surroundings, trek nearby trails, and capture stunning photographs."
  },
  {
    title: "Nakshatra Garden",
    description: "Nakshatra Garden in Satara is a well-maintained garden ideal for leisurely walks and photography. Travelers from Mumbai Airport can enjoy a peaceful stop, relax amidst greenery, and appreciate the scenic landscape on the way to Satara."
  },
  {
    title: "Shivaji Udyan",
    description: "Shivaji Udyan is a public garden in Satara featuring landscaped areas, fountains, and walking paths. Visitors traveling from Mumbai Airport can take a cab to enjoy a short stop for relaxation and sightseeing."
  },
  {
    title: "Sagareshwar Wildlife Sanctuary",
    description: "Sagareshwar Wildlife Sanctuary is a protected area near Satara offering trekking, wildlife spotting, and nature trails. Travelers from Mumbai Airport can visit this sanctuary comfortably by cab and enjoy a day immersed in nature and outdoor activities."
  }
],



services: [
{
name: "Mumbai Airport to Satara Cab Service",
description: "Mumbai Airport to Satara cab service offers a smooth and comfortable long-distance journey for travelers arriving at the airport and heading towards Satara. This service is ideal for tourists, families, and business travelers looking for a direct and hassle-free transfer. The route passes through scenic highways, ghats, and lush landscapes, making the journey enjoyable and relaxing. Professional drivers track flight timings to ensure timely pickup from Terminal 1 or Terminal 2 without delays. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs. Doorstep drop across Satara including city areas and nearby locations ensures complete convenience. With transparent pricing, easy booking, and 24x7 availability, this service guarantees a stress-free travel experience."
},
{
name: "Mumbai Airport to Satara Taxi",
description: "Mumbai Airport to Satara taxi service provides reliable and comfortable transportation with well-maintained vehicles and experienced drivers. This service is perfect for travelers who prefer a private and direct journey from the airport. Spacious seating and clean interiors ensure comfort during long-distance travel. Drivers are experienced in highway routes and ensure safe driving. Flexible pickup options from airport terminals make travel convenient. Multiple vehicle options cater to different budgets. It ensures a smooth and comfortable ride."
},
{
name: "One Way Cab Mumbai Airport to Satara",
description: "One way cab Mumbai Airport to Satara is a cost-effective solution for passengers needing a single-side drop without return charges. This service is ideal for business travelers, tourists, and personal trips. Customers benefit from competitive pricing and flexible pickup timing. Professional drivers ensure safe and timely travel across long-distance routes. Multiple vehicle options are available including sedan and SUV. Online booking with instant confirmation adds convenience. It is an efficient and affordable travel option."
},
{
name: "Mumbai Airport to Satara Cab Booking",
description: "Mumbai Airport to Satara cab booking allows customers to reserve their ride easily with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup time, and drop location as per their needs. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide secure payment options and real-time availability. Dedicated support is available for assistance. It ensures a smooth and organized travel experience. It is the easiest way to plan airport transfers."
},
{
name: "Mumbai Airport to Satara Taxi Fare",
description: "Mumbai Airport to Satara taxi fare is designed to be transparent and budget-friendly, helping travelers plan their trip efficiently. Pricing depends on vehicle type, distance, and trip duration. Customers receive a clear breakdown of costs including tolls and driver allowances where applicable. Affordable options are available for sedan and SUV categories. No hidden charges ensure trust and reliability. Flexible fare options suit different budgets. It offers excellent value for long-distance travel."
},
{
name: "Cheap Cab Mumbai Airport to Satara",
description: "Cheap cab Mumbai Airport to Satara offers budget-friendly travel options without compromising on comfort and safety. This service is ideal for cost-conscious travelers looking for reliable transportation. Sedan vehicles provide economical pricing for long journeys. Transparent billing ensures no hidden charges. Professional drivers ensure safe and smooth travel. Flexible booking options make planning easy. It is a perfect choice for affordable travel."
},
{
name: "Mumbai Airport to Satara Outstation Cab",
description: "Mumbai Airport to Satara outstation cab service provides dependable travel solutions for intercity journeys with comfort and safety. This service is suitable for tourists, families, and business travelers. Vehicles are well-maintained for long-distance highway travel. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup directly from airport terminals adds convenience. It ensures a hassle-free journey."
},
{
name: "Mumbai Airport to Satara SUV Taxi",
description: "Mumbai Airport to Satara SUV taxi is ideal for group travel and passengers needing extra space and comfort. SUVs offer spacious seating and better road performance for long-distance journeys. This option is perfect for families, friends, and corporate groups. Professional drivers ensure safe and comfortable travel throughout the route. It provides a premium travel experience. Perfect for extended road trips. It ensures a smooth journey."
},
{
name: "Mumbai Airport to Satara Sedan Cab",
description: "Mumbai Airport to Satara sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable and economical ride. Sedans offer smooth travel, good mileage, and comfortable seating for long journeys. This service is ideal for budget-friendly travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance ease of travel. It ensures a pleasant journey experience."
},
{
name: "Mumbai Airport to Satara Car Rental",
description: "Mumbai Airport to Satara car rental service provides flexible travel options with a wide range of vehicles to choose from. Customers can book cars for one way or round trip journeys. This service is ideal for personal, family, and corporate travel needs. Easy booking process and transparent pricing make it convenient. Vehicles are clean, well-maintained, and driven by professional chauffeurs. Flexible pickup from airport ensures convenience. It ensures a customized and comfortable travel experience."
},
{
name: "Private Cab Mumbai Airport to Satara",
description: "Private cab Mumbai Airport to Satara offers a personalized travel experience with exclusive vehicle usage. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey from airport to destination. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating enhances the experience. It is ideal for private and luxury travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai Airport to Satara",
description: "AC taxi Mumbai Airport to Satara ensures a comfortable journey in air-conditioned vehicles for long-distance travel. This service is ideal for passengers who prefer a cool and pleasant environment during travel. Clean interiors and well-maintained AC systems enhance comfort. Suitable for families, tourists, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing experience."
},
{
name: "Book Mumbai Airport to Satara Cab Online",
description: "Book Mumbai Airport to Satara cab online for quick and hassle-free reservations with instant confirmation. Customers can select vehicle type, pickup time, and drop location easily through online platforms. Secure payment options and transparent pricing ensure a smooth booking process. This service ensures vehicle availability even during peak hours. Dedicated support is available for assistance anytime. It simplifies travel planning for airport transfers. It is the most convenient booking option."
}
],

tableData: [
["Mumbai Airport to Satara Cab Service","Mumbai Airport to Satara Taxi"],
["One Way Cab Mumbai Airport to Satara","Mumbai Airport to Satara Cab Booking"],
["Mumbai Airport to Satara Taxi Fare","Cheap Cab Mumbai Airport to Satara"],
["Mumbai Airport to Satara Outstation Cab","Mumbai Airport to Satara SUV Taxi"],
["Mumbai Airport to Satara Sedan Cab","Mumbai Airport to Satara Car Rental"],
["Private Cab Mumbai Airport to Satara","AC Taxi Mumbai Airport to Satara"],
["Book Mumbai Airport to Satara Cab Online","Mumbai Airport to Satara Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Airport to Satara Transfer",
    WhyChoosedescription: "Velocity Cabs offers dependable Mumbai Airport to Satara cab service with timely pickups from all terminals, ensuring a smooth and hassle-free long-distance journey."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai Pune Expressway and Satara highway routes, ensuring safe driving, smooth travel, and on-time arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai Airport to Satara cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport to Satara cab service operates 24/7. Whether your flight arrives early morning or late night, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel plans between Mumbai Airport and Satara."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Satara cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport to Satara cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport to Satara for one-way and round-trip travel." },
  { question: "How far is Satara from Mumbai Airport?", answer: "The distance between Mumbai Airport and Satara is approximately 260 to 280 km and travel time is around 5.5 to 7 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai Airport to Satara cab service operates 24/7." },
  { question: "Which terminals are covered?", answer: "We provide pickup from all terminals including Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport to Satara cabs online or through phone booking." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "The ride from Mumbai Airport to Satara was very comfortable and well-coordinated. The cab was clean, and the long journey felt smooth and relaxing throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Traveling from Mumbai Airport to Satara was a hassle-free experience. The pickup was quick, the vehicle was well-maintained, and the journey felt safe and comfortable.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const mumbaiAirportSataraCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Airport to Satara Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai Airport to Satara for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai Airport to Satara Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai Airport to Satara",
        "description": "Private cab from Mumbai Airport to Satara for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai Airport to Satara Cab",
        "description": "Comfortable round-trip cab service from Mumbai Airport to Satara with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Satara Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai Airport to Satara for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportSataraCabJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttosatarscab;